// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3aei_","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3UA-a"};